
import React, { useEffect, useState } from 'react';
import ChooseGrainProfilePage from '../../pages/ChooseGrainProfilePage';
import HomePage from '../../pages/HomePage';
import ChooseLoginTypePage from '../../pages/ChooseLoginTypePage';
import ChangePasswordPage from '../../pages/ChangePasswordPage';
import ConnectRpiPage from '../../pages/ConnectRpiPage';
import ConfigureRpiWifiPage from '../../pages/ConfigureRpiWifiPage';

import CustomNavigationBar from '../CustomNavigationBar'
import ProductReleasePage from '../../pages/ProductReleasePage';
import { NativeBaseProvider } from "native-base";
import { ToastProvider } from 'react-native-toast-notifications'
import { NavigationContainer } from '@react-navigation/native';
import { nativeBaseTheme } from '../../theme'
import { useSelector } from 'react-redux';

import { createNativeStackNavigator } from '@react-navigation/native-stack';
import SettingsPage from 'src/pages/SettingsPage';
import DesktopSettingsPage from 'src/pages/SettingsPage/DesktopSettingsPage';
import GrainProfileManagementPage from 'src/pages/GrainProfileManagementPage';
import { Platform } from 'react-native';
import { getPlatform } from 'src/utils/miscUtils';
import { isNative, getDocumentTitle } from 'src/utils/utils';
import { isLightboxFeatureEnabled } from 'src/utils/grainFeatureUtils';
import UserGuidePage from 'src/pages/UserGuidePage';
import HelpPage from 'src/pages/HelpPage';
import SubscriptionPlans from 'src/components/SubscriptionPlans';
import { getText } from 'src/utils/i18n';
import ManageUserSubscription from 'src/components/ManageUserSubscription';
import AsyncStorage from '@react-native-async-storage/async-storage';
import ProgressBar from 'src/components/ProgressBar';
const Stack = createNativeStackNavigator();

const linkingConfig = {
    prefixes: ['http://localhost:8080', 'https://grams-app.com'],
    config: {
        screens: {
            Home: {
                path: '/',
                screens: {
                    Info: '',
                    Image: 'image',
                    'Indi Grains': 'readings',
                    Analysis: 'analysis',
                    History: 'history'
                }
            },
            ChooseGrainProfile: 'choose-grain-profile',
            ChooseLoginType: 'switch',
            ChangePassword: 'change-password',
            ProductRelease: 'product-release',
            Settings: 'settings',
            DesktopSettings: 'settings/desktop',
            GrainProfileManagement: 'settings/grain-profiles',
            UserGuide: 'user-guide',
            HelpPage: 'help-support',
            ConnectToRpi: 'connect-rpi',
            ConfigureRpiWifi: 'configure-wifi',
            ManageUserSubscription: 'manage-subscription',
            UserSubscriptionPlans: 'subscription-plans'
        },
    },
};

const AppUserForGrainAnalysisStack = () => {

    const colorMode = useSelector((store) => store.settings.colorMode);
    const lightboxEnabled = useSelector((store) =>
        isLightboxFeatureEnabled(store.user?.userProfile?.response?.settings)
    );
    const theme = nativeBaseTheme(colorMode);
    const [initialRouteName, setInitialRouteName] = useState(null);

    useEffect(() => {
        const checkNewSignup = async () => {
            if (Platform.OS === 'web') {
                const isNewSignupFlag = await AsyncStorage.getItem('isNewSignup');
                if (isNewSignupFlag === 'true') {
                    setInitialRouteName('ChooseGrainProfile');
                } else {
                    setInitialRouteName('Home');
                }
            } else {
                setInitialRouteName('ChooseGrainProfile');
            }
        };
        checkNewSignup();
    }, []);

    if (initialRouteName === null) {
        // Show loader while determining initial route
        return <ToastProvider>
            <NativeBaseProvider theme={theme}>
                <ProgressBar isVisible={true} progressText={getText('loading')} />
            </NativeBaseProvider>
        </ToastProvider>;
    }

    return <ToastProvider>
        <NativeBaseProvider theme={theme}>
            <React.Fragment>

                {
                    Platform.OS === "web" ? <style type="text/css">{`
                    @font-face {
                      font-family: 'MaterialCommunityIcons';
                      src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
                    }
                  `}</style> : null
                }
                <NavigationContainer
                    documentTitle={{
                        formatter: (options, route) =>
                            getDocumentTitle()
                    }}
                    linking={getPlatform() === "web" ? linkingConfig : null}
                >
                    <Stack.Navigator
                        initialRouteName={initialRouteName}
                        screenOptions={{
                            header: (props) => <CustomNavigationBar {...props} />,
                        }}>
                        <Stack.Screen
                            name="ChooseLoginType"
                            component={ChooseLoginTypePage}
                            options={{
                                showTitle: true,
                                title: 'Change Role',
                                settings: false,
                                previous: false
                            }} />
                        <Stack.Screen
                            name="ChooseGrainProfile"
                            component={ChooseGrainProfilePage}
                            options={{
                                showTitle: true,
                                title: 'Choose Grain Profile',
                                settings: false,
                                previous: false
                            }} />
                        <Stack.Screen
                            name="Home"
                            component={HomePage}
                            options={{
                                title: 'Home',
                                showTitle: false,
                                settings: true,
                                logo: true,
                                previous: false
                            }} />
                        {
                            isNative() && !lightboxEnabled ?
                                <>
                                    <Stack.Screen
                                        name="ConnectToRpi"
                                        component={ConnectRpiPage}
                                        options={{
                                            showTitle: true,
                                            title: 'Connect to InstaGrainX IoT device',
                                            settings: false,
                                            previous: true
                                        }} />
                                    <Stack.Screen
                                        name="ConfigureRpiWifi"
                                        component={ConfigureRpiWifiPage}
                                        options={{
                                            showTitle: true,
                                            title: 'Configure IoT device WiFi',
                                            settings: false,
                                            previous: true
                                        }} />
                                </> : null
                        }
                        <Stack.Screen
                            name="ChangePassword"
                            component={ChangePasswordPage}
                            options={{
                                previous: true,
                                showTitle: true,
                                title: 'Change Password',
                                settings: false
                            }} />
                        {
                            getPlatform() === "web" ?
                                <Stack.Screen
                                    name="ProductRelease"
                                    component={ProductReleasePage}
                                    options={{
                                        headerShown: false,
                                        title: "Product Releases",
                                        previous: true
                                    }} />
                                : null
                        }
                        <Stack.Screen
                            name="Settings"
                            component={SettingsPage}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: "Settings",
                                previous: true
                            }} />
                        <Stack.Screen
                            name="DesktopSettings"
                            component={DesktopSettingsPage}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: "Desktop Settings",
                                previous: true
                            }} />
                        <Stack.Screen
                            name="GrainProfileManagement"
                            component={GrainProfileManagementPage}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: "Grain Profiles",
                                previous: true
                            }} />
                        <Stack.Screen
                            name="UserGuide"
                            component={UserGuidePage}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: 'User Guide',
                                previous: true,
                                }}
                        />
                        <Stack.Screen
                            name="HelpPage"
                            component={HelpPage}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: 'Help & Support',
                                previous: true,
                                }}
                        />
                        <Stack.Screen
                            name="ManageUserSubscription"
                            component={ManageUserSubscription}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: 'Manage Subscription',
                                previous: true,
                                }}
                        />
                        <Stack.Screen
                            name="UserSubscriptionPlans"
                            component={SubscriptionPlans}
                            options={{
                                showTitle: true,
                                headerShown: true,
                                title: 'Subscription Plans',
                                previous: true,
                                }}
                        />
                    </Stack.Navigator>
                </NavigationContainer>
            </React.Fragment>
        </NativeBaseProvider>
    </ToastProvider>
}

export {
    AppUserForGrainAnalysisStack
}
